<script>
	import { createEventDispatcher } from 'svelte';
	import Icon from '../icons/Icon.svelte';

	const dispatch = createEventDispatcher();

	export let categories = [];
	export let products = [];
	export let selectedCategoryId = "all";
	export let selectedCategory = { id: "all", name: "Todas as Categorias", active: true };
	export let categoryProducts = [];
	export let totalProductsCount = 0;
	export let openCategoryMenuId = null;

	// Busca e Filtros de Produtos locais deste layout
	let searchQuery = "";
	let filterAvailability = "all"; // 'all' | 'active' | 'paused' | 'promo'

	$: filteredProducts = categoryProducts.filter(p => {
		if (searchQuery.trim()) {
			const q = searchQuery.toLowerCase().trim();
			const nameMatch = (p.name || "").toLowerCase().includes(q);
			const descMatch = (p.description || "").toLowerCase().includes(q);
			if (!nameMatch && !descMatch) return false;
		}
		if (filterAvailability === "active") return Boolean(p.active);
		if (filterAvailability === "paused") return !p.active;
		if (filterAvailability === "promo") return Number(p.promoPrice) > 0;
		return true;
	});

	function getCategoryName(catId) {
		const cat = categories.find(c => c.id === catId);
		return cat ? cat.name : "Geral";
	}

	function handleSelectCategory(catId) {
		selectedCategoryId = catId;
		dispatch('selectCategory', catId);
	}

	function handleOpenNewCategoryModal() {
		dispatch('openNewCategoryModal');
	}

	function handleOpenEditCategoryModal(cat) {
		dispatch('openEditCategoryModal', cat);
	}

	function handleOpenDrawerForCategory(cat) {
		dispatch('openDrawerForCategory', cat);
	}

	function handleToggleCategory(cat) {
		dispatch('toggleCategory', cat);
	}

	function handleMoveCategory(cat, dir) {
		dispatch('moveCategory', { cat, dir });
	}

	function handleDeleteCategory(cat) {
		dispatch('deleteCategory', cat);
	}

	function handleOpenCategoryDrawer() {
		dispatch('openCategoryDrawer');
	}

	function handleOpenNewProductModal() {
		dispatch('openNewProductModal');
	}

	function handleToggleProduct(prod) {
		dispatch('toggleProduct', prod);
	}

	function handleOpenEditProductModal(prod) {
		dispatch('openEditProductModal', prod);
	}

	function handleDeleteProduct(prod) {
		dispatch('deleteProduct', prod);
	}

	function handleToggleCategoryMenu(catId) {
		dispatch('toggleCategoryMenu', catId);
	}
</script>

<div class="layout-agile-container">
			<!-- COLUNA LATERAL DE CATEGORIAS -->
			<aside class="col-categories">
				<div class="categories-header">
					<div class="cat-header-title">
						<h3>Categorias</h3>
						<span class="count-pill">{categories.length}</span>
					</div>
					<button type="button" class="btn-mini-add-cat" on:click={handleOpenNewCategoryModal} title="Criar Nova Categoria">
						<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
							<line x1="12" y1="5" x2="12" y2="19"></line>
							<line x1="5" y1="12" x2="19" y2="12"></line>
						</svg>
						<span>Nova</span>
					</button>
				</div>

				<div class="categories-scroll-area">
					<!-- Item fixo: Todas as Categorias -->
					<div
						class="category-nav-card {selectedCategoryId === 'all' ? 'active' : ''}"
						on:click={() => handleSelectCategory("all")}
					>
						<div class="cat-nav-left">
							<div class="cat-icon-frame all-frame">
								<Icon name="package" size={16} color="#FF6A00" />
							</div>
							<div class="cat-nav-texts">
								<span class="cat-nav-name">Todas as Categorias</span>
								<span class="cat-nav-sub">{totalProductsCount} itens no total</span>
							</div>
						</div>
						<div class="cat-nav-right">
							<span class="cat-badge-counter">{totalProductsCount}</span>
						</div>
					</div>

					<div class="cat-list-divider"></div>

					<!-- Lista de Categorias Específicas -->
					{#if categories.length === 0}
						<div class="empty-categories-hint">
							<Icon name="utensils" size={24} color="#94A3B8" />
							<span>Nenhuma categoria criada</span>
							<button type="button" class="btn-link" on:click={handleOpenNewCategoryModal}>+ Criar categoria</button>
						</div>
					{:else}
						{#each categories as cat, index (cat.id)}
							<div
								class="category-nav-card {selectedCategoryId === cat.id ? 'active' : ''} {!cat.active ? 'disabled' : ''}"
								on:click={() => handleSelectCategory(cat.id)}
							>
								<div class="cat-nav-left">
									{#if cat.image}
										<img src={cat.image} alt={cat.name} class="cat-nav-thumb" />
									{:else}
										<div class="cat-icon-frame">
											<Icon name="utensils" size={15} color="#475569" />
										</div>
									{/if}
									<div class="cat-nav-texts">
										<span class="cat-nav-name">{cat.name}</span>
										<span class="cat-nav-sub">
											{products.filter(p => p.categoryId === cat.id || p.category_id === cat.id).length} itens
										</span>
									</div>
								</div>

								<div class="cat-nav-right">
									<!-- Status Indicator -->
									<span
										class="cat-status-bullet {cat.active ? 'status-online' : 'status-offline'}"
										title={cat.active ? 'Categoria ativa no cardápio' : 'Categoria pausada (oculta)'}
									></span>

									<!-- Menu Contextual (⋮) -->
									<div class="cat-menu-wrapper" on:click|stopPropagation>
										<button
											type="button"
											class="btn-cat-kebab"
											on:click={() => handleToggleCategoryMenu(cat.id)}
											title="Opções da categoria"
										>
											⋮
										</button>

										{#if openCategoryMenuId === cat.id}
											<div class="cat-popover-menu">
												<button
													type="button"
													class="popover-btn"
													on:click={() => handleOpenEditCategoryModal(cat)}
												>
													<Icon name="edit" size={14} />
													<span>Editar dados</span>
												</button>

												<button
													type="button"
													class="popover-btn"
													on:click={() => handleOpenDrawerForCategory(cat)}
												>
													<Icon name="settings" size={14} />
													<span>Configurações & foto</span>
												</button>

												<button
													type="button"
													class="popover-btn"
													on:click={() => handleToggleCategory(cat)}
												>
													{#if cat.active}
														<Icon name="pause" size={14} color="#F59E0B" />
														<span>Pausar categoria</span>
													{:else}
														<Icon name="play" size={14} color="#10B981" />
														<span>Ativar categoria</span>
													{/if}
												</button>

												<div class="popover-hr"></div>

												<button
													type="button"
													class="popover-btn"
													disabled={index === 0}
													on:click={() => handleMoveCategory(cat, 'up')}
												>
													<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
														<polyline points="18 15 12 9 6 15"></polyline>
													</svg>
													<span>Mover para cima</span>
												</button>

												<button
													type="button"
													class="popover-btn"
													disabled={index === categories.length - 1}
													on:click={() => handleMoveCategory(cat, 'down')}
												>
													<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
														<polyline points="6 9 12 15 18 9"></polyline>
													</svg>
													<span>Mover para baixo</span>
												</button>

												<div class="popover-hr"></div>

												<button
													type="button"
													class="popover-btn danger"
													on:click={() => handleDeleteCategory(cat)}
												>
													<Icon name="trash" size={14} color="#EF4444" />
													<span>Excluir categoria</span>
												</button>
											</div>
										{/if}
									</div>
								</div>
							</div>
						{/each}
					{/if}
				</div>
			</aside>

			<!-- COLUNA PRINCIPAL DE PRODUTOS -->
			<main class="col-products">
				<!-- Header da Categoria Ativa / Banner de Contexto -->
				<div class="category-banner-card">
					<div class="banner-info-left">
						{#if selectedCategory.id === "all"}
							<div class="banner-icon-all">
								<Icon name="package" size={24} color="#FF6A00" />
							</div>
						{:else if selectedCategory.image}
							<img src={selectedCategory.image} alt={selectedCategory.name} class="banner-cat-photo" />
						{:else}
							<div class="banner-cat-icon">
								<Icon name="utensils" size={24} color="#FF6A00" />
							</div>
						{/if}

						<div class="banner-cat-details">
							<div class="banner-title-row">
								<h2>{selectedCategory.name}</h2>
								<span class="badge-total-items">
									{categoryProducts.length} {categoryProducts.length === 1 ? 'item' : 'itens'}
								</span>
								{#if selectedCategory.id !== "all"}
									<span class="badge-cat-status {selectedCategory.active ? 'status-active' : 'status-paused'}">
										{selectedCategory.active ? 'Ativa no Cardápio' : 'Pausada'}
									</span>
								{/if}
							</div>
							<p class="banner-desc">{selectedCategory.description || "Nenhuma descrição cadastrada para esta categoria."}</p>
						</div>
					</div>

					<div class="banner-actions-right">
						{#if selectedCategory.id !== "all"}
							<button
								type="button"
								class="btn-banner-action"
								on:click={handleOpenCategoryDrawer}
								title="Configurar imagem de capa e visibilidade da categoria"
							>
								<Icon name="settings" size={14} />
								<span>Configurar</span>
							</button>
						{/if}

						<button
							type="button"
							class="btn-banner-primary"
							on:click={handleOpenNewProductModal}
							title="Adicionar novo produto nesta categoria"
						>
							<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
								<line x1="12" y1="5" x2="12" y2="19"></line>
								<line x1="5" y1="12" x2="19" y2="12"></line>
							</svg>
							<span>+ Novo Produto</span>
						</button>
					</div>
				</div>

				<!-- BARRA DE BUSCA E FILTROS RÁPIDOS -->
				<div class="search-filter-toolbar">
					<div class="search-box">
						<span class="search-svg"><Icon name="search-icon" size={16} color="#64748B" /></span>
						<input
							type="text"
							placeholder="Buscar produto por nome ou ingredientes..."
							bind:value={searchQuery}
							class="search-input"
						/>
						{#if searchQuery}
							<button type="button" class="btn-clear-search" on:click={() => (searchQuery = "")} title="Limpar busca">
								<Icon name="x" size={14} />
							</button>
						{/if}
					</div>

					<div class="filter-pills-row">
						<button
							type="button"
							class="filter-pill {filterAvailability === 'all' ? 'active' : ''}"
							on:click={() => (filterAvailability = 'all')}
						>
							Todos <span class="pill-badge">{categoryProducts.length}</span>
						</button>
						<button
							type="button"
							class="filter-pill {filterAvailability === 'active' ? 'active' : ''}"
							on:click={() => (filterAvailability = 'active')}
						>
							Disponíveis <span class="pill-badge pill-emerald">{categoryProducts.filter(p => p.active).length}</span>
						</button>
						<button
							type="button"
							class="filter-pill {filterAvailability === 'paused' ? 'active' : ''}"
							on:click={() => (filterAvailability = 'paused')}
						>
							Pausados <span class="pill-badge">{categoryProducts.filter(p => !p.active).length}</span>
						</button>
						<button
							type="button"
							class="filter-pill {filterAvailability === 'promo' ? 'active' : ''}"
							on:click={() => (filterAvailability = 'promo')}
						>
							Promoção <span class="pill-badge pill-orange">{categoryProducts.filter(p => Number(p.promoPrice) > 0).length}</span>
						</button>
					</div>
				</div>

				<!-- LISTA / GRID DE PRODUTOS -->
				<div class="products-content-scroll">
					{#if filteredProducts.length === 0}
						<div class="empty-catalog-state">
							{#if searchQuery.trim()}
								<div class="empty-icon-circle">
									<Icon name="search-icon" size={32} color="#94A3B8" />
								</div>
								<h4>Nenhum produto encontrado</h4>
								<p>Não encontramos produtos correspondentes a "<strong>{searchQuery}</strong>" nesta categoria.</p>
								<button type="button" class="btn-clear-empty" on:click={() => (searchQuery = "")}>
									Limpar filtros de busca
								</button>
							{:else}
								<div class="empty-icon-circle">
									<Icon name="package" size={36} color="#FF6A00" />
								</div>
								<h4>Nenhum produto nesta categoria</h4>
								<p>Cadastre os pratos, combos, bebidas ou sobremesas para exibir no cardápio online e balcão.</p>
								<button type="button" class="btn-primary-empty" on:click={handleOpenNewProductModal}>
									+ Cadastrar Primeiro Produto
								</button>
							{/if}
						</div>
					{:else}
						<div class="products-cards-grid">
							{#each filteredProducts as prod (prod.id)}
								<div class="product-saas-card {!prod.active ? 'is-paused' : ''}">
									<!-- Bloco de Imagem -->
									<div class="card-thumb-area">
										{#if prod.image}
											<img src={prod.image} alt={prod.name} class="product-cover-img" loading="lazy" />
										{:else}
											<div class="product-cover-fallback">
												<Icon name="utensils" size={28} color="#CBD5E1" />
												<span class="no-img-text">Sem foto</span>
											</div>
										{/if}

										<!-- Badges Sobrepostas -->
										<div class="thumb-overlays">
											<span class="stock-badge {prod.active ? 'badge-available' : 'badge-paused'}">
												<span class="indicator-bullet"></span>
												<span>{prod.active ? 'Disponível' : 'Pausado'}</span>
											</span>

											{#if prod.promoPrice > 0}
												<span class="promo-badge-tag">PROMOÇÃO</span>
											{/if}
										</div>
									</div>

									<!-- Corpo do Card -->
									<div class="card-content-area">
										<div class="product-header-line">
											<h4 class="product-title" title={prod.name}>{prod.name}</h4>
											{#if selectedCategoryId === "all"}
												<span class="cat-pill-reference">
													{getCategoryName(prod.categoryId || prod.category_id)}
												</span>
											{/if}
										</div>

										<p class="product-desc" title={prod.description}>
											{prod.description || "Sem ingredientes descritos."}
										</p>

										<!-- Chips de Modificadores / Complementos -->
										{#if prod.modifierGroups && prod.modifierGroups.length > 0}
											<div class="modifiers-chips-row">
												{#each prod.modifierGroups as mod}
													<span class="mod-chip" title="{mod.name}: {mod.options.length} opções">
														<Icon name="tag" size={11} color="#64748B" />
														<span>{mod.name} ({mod.options.length})</span>
													</span>
												{/each}
											</div>
										{/if}

										<!-- Bloco de Preço e Estoque -->
										<div class="price-stock-row">
											<div class="price-display-block">
												{#if prod.promoPrice > 0}
													<div class="price-with-promo">
														<span class="price-strikethrough">R$ {prod.price.toFixed(2)}</span>
														<span class="price-highlight promo">R$ {prod.promoPrice.toFixed(2)}</span>
													</div>
												{:else}
													<span class="price-highlight">R$ {prod.price.toFixed(2)}</span>
												{/if}
											</div>

											{#if prod.track_stock}
												{#if (prod.stock_quantity ?? 0) <= 0}
													<span class="admin-stock-pill stock-out" title="Produto esgotado no estoque">
														<Icon name="package" size={11} />
														<span>Esgotado</span>
													</span>
												{:else}
													<span class="admin-stock-pill stock-available" title="Estoque disponível: {prod.stock_quantity} unidades">
														<Icon name="package" size={11} />
														<span>{prod.stock_quantity} un.</span>
													</span>
												{/if}
											{/if}
										</div>
									</div>

									<!-- Rodapé com Ações -->
									<div class="card-footer-actions">
										<button
											type="button"
											class="btn-stock-toggle {prod.active ? 'active' : 'paused'}"
											on:click={() => handleToggleProduct(prod)}
											title={prod.active ? 'Clique para pausar item' : 'Clique para marcar como disponível'}
										>
											<span class="toggle-dot"></span>
											<span>{prod.active ? 'Disponível' : 'Pausado'}</span>
										</button>

										<div class="footer-buttons-group">
											<button
												type="button"
												class="btn-card-edit"
												on:click={() => handleOpenEditProductModal(prod)}
												title="Editar informações do produto"
											>
												<Icon name="edit" size={14} />
												<span>Editar</span>
											</button>

											<button
												type="button"
												class="btn-card-delete"
												on:click={() => handleDeleteProduct(prod)}
												title="Excluir produto do cardápio"
											>
												<Icon name="trash" size={14} color="#EF4444" />
											</button>
										</div>
									</div>
								</div>
							{/each}
						</div>
					{/if}
				</div>
			</main>
		</div>

<style>
	/* ========================================================
	   LAYOUT 1: VISUALIZAÇÃO ÁGIL (COLUNAS)
	   ======================================================== */
	.layout-agile-container {
		display: flex;
		flex: 1;
		height: calc(100% - 65px);
		overflow: hidden;
	}

	/* Coluna de Categorias */
	.col-categories {
		width: 280px;
		min-width: 250px;
		max-width: 320px;
		background: #FFFFFF;
		border-right: 1px solid var(--neutral-border, #E2E8F0);
		display: flex;
		flex-direction: column;
		flex-shrink: 0;
	}

	.categories-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 14px 16px;
		border-bottom: 1px solid #E2E8F0;
	}

	.cat-header-title {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.cat-header-title h3 {
		margin: 0;
		font-size: 14px;
		font-weight: 700;
		color: #0F172A;
	}

	.count-pill {
		background: #F1F5F9;
		color: #475569;
		font-size: 11px;
		font-weight: 700;
		padding: 2px 7px;
		border-radius: 12px;
	}

	.btn-mini-add-cat {
		display: flex;
		align-items: center;
		gap: 4px;
		padding: 4px 8px;
		background: #FFF7ED;
		border: 1px solid #FFEDD5;
		border-radius: 6px;
		font-size: 12px;
		font-weight: 700;
		color: #FF6A00;
		cursor: pointer;
		transition: all 0.12s;
	}

	.btn-mini-add-cat:hover {
		background: #FFEDD5;
		border-color: #FED7AA;
	}

	.categories-scroll-area {
		flex: 1;
		overflow-y: auto;
		padding: 8px;
		display: flex;
		flex-direction: column;
		gap: 4px;
	}

	.category-nav-card {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 8px 10px;
		border-radius: 8px;
		border: 1px solid transparent;
		cursor: pointer;
		background: transparent;
		transition: all 0.12s ease;
	}

	.category-nav-card:hover {
		background: #F8FAFC;
		border-color: #E2E8F0;
	}

	.category-nav-card.active {
		background: #FFF7ED;
		border-color: #FFDBB5;
	}

	.category-nav-card.active .cat-nav-name {
		color: #FF6A00;
		font-weight: 700;
	}

	.category-nav-card.disabled {
		opacity: 0.6;
	}

	.cat-nav-left {
		display: flex;
		align-items: center;
		gap: 10px;
		min-width: 0;
		flex: 1;
	}

	.cat-icon-frame {
		width: 32px;
		height: 32px;
		border-radius: 6px;
		background: #F1F5F9;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
	}

	.cat-icon-frame.all-frame {
		background: #FFF7ED;
	}

	.cat-nav-thumb {
		width: 32px;
		height: 32px;
		border-radius: 6px;
		object-fit: cover;
		flex-shrink: 0;
		border: 1px solid #E2E8F0;
	}

	.cat-nav-texts {
		display: flex;
		flex-direction: column;
		min-width: 0;
	}

	.cat-nav-name {
		font-size: 13px;
		font-weight: 600;
		color: #1E293B;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.cat-nav-sub {
		font-size: 11px;
		color: #64748B;
		margin-top: 1px;
	}

	.cat-nav-right {
		display: flex;
		align-items: center;
		gap: 6px;
	}

	.cat-badge-counter {
		background: #F1F5F9;
		color: #475569;
		font-size: 11px;
		font-weight: 700;
		padding: 2px 6px;
		border-radius: 10px;
	}

	.cat-status-bullet {
		width: 7px;
		height: 7px;
		border-radius: 50%;
	}

	.cat-status-bullet.status-online {
		background: #10B981;
	}

	.cat-status-bullet.status-offline {
		background: #94A3B8;
	}

	.cat-menu-wrapper {
		position: relative;
	}

	.btn-cat-kebab {
		width: 24px;
		height: 24px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: transparent;
		border: none;
		border-radius: 4px;
		color: #94A3B8;
		font-size: 16px;
		cursor: pointer;
		transition: all 0.12s;
	}

	.btn-cat-kebab:hover {
		background: #E2E8F0;
		color: #0F172A;
	}

	.cat-popover-menu {
		position: absolute;
		top: calc(100% + 4px);
		right: 0;
		width: 190px;
		background: #FFFFFF;
		border: 1px solid #E2E8F0;
		border-radius: 8px;
		box-shadow: 0 10px 20px -5px rgba(0, 0, 0, 0.1);
		padding: 4px;
		z-index: 90;
	}

	.popover-btn {
		display: flex;
		align-items: center;
		gap: 8px;
		width: 100%;
		padding: 7px 10px;
		background: transparent;
		border: none;
		border-radius: 6px;
		font-size: 12px;
		font-weight: 500;
		color: #334155;
		cursor: pointer;
		transition: background 0.1s;
		text-align: left;
	}

	.popover-btn:hover:not(:disabled) {
		background: #F1F5F9;
		color: #0F172A;
	}

	.popover-btn:disabled {
		opacity: 0.4;
		cursor: not-allowed;
	}

	.popover-btn.danger {
		color: #EF4444;
	}

	.popover-btn.danger:hover {
		background: #FEF2F2;
	}

	.popover-hr {
		height: 1px;
		background: #F1F5F9;
		margin: 4px 0;
	}

	.cat-list-divider {
		height: 1px;
		background: #E2E8F0;
		margin: 4px 4px;
	}

	.empty-categories-hint {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 8px;
		padding: 32px 16px;
		text-align: center;
		color: #64748B;
		font-size: 12px;
	}

	.btn-link {
		background: transparent;
		border: none;
		color: #FF6A00;
		font-weight: 700;
		font-size: 12px;
		cursor: pointer;
		padding: 0;
	}

	.btn-link:hover {
		text-decoration: underline;
	}

	/* Coluna de Produtos */
	.col-products {
		flex: 1;
		display: flex;
		flex-direction: column;
		background: #F8FAFC;
		overflow: hidden;
	}

	/* Banner da Categoria Ativa */
	.category-banner-card {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 14px 24px;
		background: #FFFFFF;
		border-bottom: 1px solid #E2E8F0;
		flex-shrink: 0;
		gap: 16px;
	}

	.banner-info-left {
		display: flex;
		align-items: center;
		gap: 14px;
		min-width: 0;
	}

	.banner-icon-all, .banner-cat-icon {
		width: 44px;
		height: 44px;
		border-radius: 10px;
		background: #FFF7ED;
		border: 1px solid #FFEDD5;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
	}

	.banner-cat-photo {
		width: 44px;
		height: 44px;
		border-radius: 10px;
		object-fit: cover;
		border: 1px solid #E2E8F0;
		flex-shrink: 0;
	}

	.banner-cat-details {
		min-width: 0;
	}

	.banner-title-row {
		display: flex;
		align-items: center;
		gap: 8px;
		flex-wrap: wrap;
	}

	.banner-title-row h2 {
		margin: 0;
		font-size: 17px;
		font-weight: 800;
		color: #0F172A;
		letter-spacing: -0.01em;
	}

	.badge-total-items {
		background: #F1F5F9;
		color: #475569;
		font-size: 12px;
		font-weight: 700;
		padding: 2px 8px;
		border-radius: 12px;
	}

	.badge-cat-status {
		font-size: 11px;
		font-weight: 600;
		padding: 2px 8px;
		border-radius: 10px;
	}

	.badge-cat-status.status-active {
		background: #ECFDF5;
		color: #047857;
	}

	.badge-cat-status.status-paused {
		background: #FEF3C7;
		color: #B45309;
	}

	.banner-desc {
		margin: 2px 0 0 0;
		font-size: 12px;
		color: #64748B;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		max-width: 600px;
	}

	.banner-actions-right {
		display: flex;
		align-items: center;
		gap: 8px;
		flex-shrink: 0;
	}

	.btn-banner-action {
		display: flex;
		align-items: center;
		gap: 6px;
		height: 34px;
		padding: 0 12px;
		background: #FFFFFF;
		border: 1px solid #CBD5E1;
		border-radius: 8px;
		font-size: 12px;
		font-weight: 600;
		color: #334155;
		cursor: pointer;
		transition: all 0.12s;
	}

	.btn-banner-action:hover:not(:disabled) {
		background: #F8FAFC;
		border-color: #94A3B8;
		color: #0F172A;
	}


	.btn-banner-primary {
		display: flex;
		align-items: center;
		gap: 6px;
		height: 34px;
		padding: 0 14px;
		background: var(--brand-primary, #FF6A00);
		border: 1px solid transparent;
		border-radius: 8px;
		font-size: 12px;
		font-weight: 700;
		color: #FFFFFF;
		cursor: pointer;
		transition: all 0.12s;
	}

	.btn-banner-primary:hover {
		background: #E85A00;
	}

	/* Barra de Busca e Filtros */
	.search-filter-toolbar {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 10px 24px;
		background: #FFFFFF;
		border-bottom: 1px solid #E2E8F0;
		gap: 16px;
		flex-shrink: 0;
		flex-wrap: wrap;
	}

	.search-box {
		position: relative;
		display: flex;
		align-items: center;
		flex: 1;
		max-width: 440px;
	}

	.search-svg {
		position: absolute;
		left: 12px;
		pointer-events: none;
		display: flex;
		align-items: center;
	}

	.search-input {
		width: 100%;
		height: 36px;
		padding: 0 32px 0 36px;
		background: #F8FAFC;
		border: 1px solid #CBD5E1;
		border-radius: 8px;
		font-size: 13px;
		color: #0F172A;
		transition: all 0.12s;
	}

	.search-input:focus {
		outline: none;
		background: #FFFFFF;
		border-color: #FF6A00;
		box-shadow: 0 0 0 2px rgba(255, 106, 0, 0.15);
	}

	.btn-clear-search {
		position: absolute;
		right: 8px;
		background: transparent;
		border: none;
		color: #94A3B8;
		cursor: pointer;
		padding: 4px;
		display: flex;
		align-items: center;
	}

	.btn-clear-search:hover {
		color: #0F172A;
	}

	.filter-pills-row {
		display: flex;
		align-items: center;
		gap: 6px;
		flex-wrap: wrap;
	}

	.filter-pill {
		display: flex;
		align-items: center;
		gap: 6px;
		height: 32px;
		padding: 0 12px;
		background: #F8FAFC;
		border: 1px solid #E2E8F0;
		border-radius: 20px;
		font-size: 12px;
		font-weight: 600;
		color: #475569;
		cursor: pointer;
		transition: all 0.12s;
	}

	.filter-pill:hover {
		background: #F1F5F9;
		color: #0F172A;
	}

	.filter-pill.active {
		background: #0F172A;
		border-color: #0F172A;
		color: #FFFFFF;
	}

	.pill-badge {
		font-size: 11px;
		font-weight: 700;
		padding: 1px 6px;
		border-radius: 10px;
		background: rgba(0, 0, 0, 0.08);
	}

	.filter-pill.active .pill-badge {
		background: rgba(255, 255, 255, 0.2);
	}

	.pill-badge.pill-emerald {
		background: #DCFCE7;
		color: #166534;
	}

	.filter-pill.active .pill-badge.pill-emerald {
		background: #10B981;
		color: #FFFFFF;
	}

	.pill-badge.pill-orange {
		background: #FFEDD5;
		color: #C2410C;
	}

	.filter-pill.active .pill-badge.pill-orange {
		background: #FF6A00;
		color: #FFFFFF;
	}

	/* Scroll de Produtos */
	.products-content-scroll {
		flex: 1;
		overflow-y: auto;
		padding: 20px 24px;
	}

	/* Grid de Cards */
	.products-cards-grid {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
		gap: 16px;
	}

	/* Card Individual de Produto */
	.product-saas-card {
		display: flex;
		flex-direction: column;
		background: #FFFFFF;
		border: 1px solid var(--neutral-border, #E2E8F0);
		border-radius: var(--radius-lg, 14px);
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
		overflow: hidden;
		transition: all 0.18s ease;
	}

	.product-saas-card:hover {
		border-color: #CBD5E1;
		box-shadow: 0 6px 16px -4px rgba(0, 0, 0, 0.08);
		transform: translateY(-2px);
	}

	.product-saas-card.is-paused {
		opacity: 0.72;
		background: #FAFAFA;
	}

	/* Área de Foto */
	.card-thumb-area {
		position: relative;
		width: 100%;
		height: 155px;
		background: #F1F5F9;
		overflow: hidden;
	}

	.product-cover-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		transition: transform 0.3s ease;
	}

	.product-saas-card:hover .product-cover-img {
		transform: scale(1.03);
	}

	.product-cover-fallback {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 100%;
		gap: 6px;
		background: #F8FAFC;
	}

	.no-img-text {
		font-size: 11px;
		font-weight: 600;
		color: #94A3B8;
	}

	.thumb-overlays {
		position: absolute;
		top: 10px;
		left: 10px;
		right: 10px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		pointer-events: none;
	}

	.stock-badge {
		display: inline-flex;
		align-items: center;
		gap: 5px;
		padding: 3px 8px;
		border-radius: 12px;
		font-size: 11px;
		font-weight: 700;
		backdrop-filter: blur(8px);
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
	}

	.stock-badge.badge-available {
		background: rgba(16, 185, 129, 0.92);
		color: #FFFFFF;
	}

	.stock-badge.badge-paused {
		background: rgba(100, 116, 139, 0.92);
		color: #FFFFFF;
	}

	.indicator-bullet {
		width: 5px;
		height: 5px;
		border-radius: 50%;
		background: #FFFFFF;
	}

	.promo-badge-tag {
		background: #FF6A00;
		color: #FFFFFF;
		font-size: 10px;
		font-weight: 800;
		padding: 3px 8px;
		border-radius: 12px;
		letter-spacing: 0.05em;
		box-shadow: 0 2px 4px rgba(255, 106, 0, 0.3);
	}

	/* Corpo do Card */
	.card-content-area {
		padding: 14px;
		display: flex;
		flex-direction: column;
		flex: 1;
	}

	.product-header-line {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		gap: 8px;
		margin-bottom: 4px;
	}

	.product-title {
		margin: 0;
		font-size: 15px;
		font-weight: 700;
		color: #0F172A;
		line-height: 1.3;
	}

	.cat-pill-reference {
		font-size: 10px;
		font-weight: 700;
		background: #F1F5F9;
		color: #475569;
		padding: 2px 6px;
		border-radius: 6px;
		white-space: nowrap;
		flex-shrink: 0;
	}

	.product-desc {
		margin: 4px 0 8px 0;
		font-size: 12px;
		color: #64748B;
		line-height: 1.45;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
		flex: 1;
	}

	.modifiers-chips-row {
		display: flex;
		align-items: center;
		gap: 6px;
		flex-wrap: wrap;
		margin-bottom: 10px;
	}

	.mod-chip {
		display: inline-flex;
		align-items: center;
		gap: 4px;
		background: #F1F5F9;
		border: 1px solid #E2E8F0;
		padding: 2px 6px;
		border-radius: 6px;
		font-size: 10px;
		font-weight: 600;
		color: #475569;
	}

	.price-display-block {
		margin-top: auto;
		padding-top: 6px;
	}

	.price-highlight {
		font-size: 16px;
		font-weight: 800;
		color: #0F172A;
		letter-spacing: -0.01em;
	}

	.price-highlight.promo {
		color: #FF6A00;
	}

	.price-with-promo {
		display: flex;
		align-items: baseline;
		gap: 8px;
	}

	.price-strikethrough {
		font-size: 13px;
		color: #94A3B8;
		text-decoration: line-through;
	}

	/* Ações do Rodapé do Card */
	.card-footer-actions {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 10px 14px;
		background: #FAFAFA;
		border-top: 1px solid #F1F5F9;
	}

	.btn-stock-toggle {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		height: 28px;
		padding: 0 10px;
		border-radius: 14px;
		font-size: 11px;
		font-weight: 700;
		cursor: pointer;
		border: 1px solid transparent;
		transition: all 0.12s;
	}

	.btn-stock-toggle.active {
		background: #DCFCE7;
		border-color: #BBF7D0;
		color: #166534;
	}

	.btn-stock-toggle.active:hover {
		background: #BBF7D0;
	}

	.btn-stock-toggle.paused {
		background: #F1F5F9;
		border-color: #E2E8F0;
		color: #64748B;
	}

	.btn-stock-toggle.paused:hover {
		background: #E2E8F0;
		color: #0F172A;
	}

	.toggle-dot {
		width: 6px;
		height: 6px;
		border-radius: 50%;
	}

	.btn-stock-toggle.active .toggle-dot {
		background: #10B981;
	}

	.btn-stock-toggle.paused .toggle-dot {
		background: #94A3B8;
	}

	.footer-buttons-group {
		display: flex;
		align-items: center;
		gap: 6px;
	}

	.btn-card-edit {
		display: flex;
		align-items: center;
		gap: 5px;
		height: 28px;
		padding: 0 10px;
		background: #FFFFFF;
		border: 1px solid #CBD5E1;
		border-radius: 6px;
		font-size: 12px;
		font-weight: 600;
		color: #334155;
		cursor: pointer;
		transition: all 0.12s;
	}

	.btn-card-edit:hover {
		background: #F8FAFC;
		border-color: #94A3B8;
		color: #0F172A;
	}

	.btn-card-delete {
		width: 28px;
		height: 28px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #FFFFFF;
		border: 1px solid #FCA5A5;
		border-radius: 6px;
		cursor: pointer;
		transition: all 0.12s;
	}

	.btn-card-delete:hover {
		background: #FEF2F2;
		border-color: #EF4444;
	}

	/* Estados Vazios */
	.empty-catalog-state {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 60px 20px;
		text-align: center;
		background: #FFFFFF;
		border: 1px dashed #CBD5E1;
		border-radius: 16px;
		margin: 20px 0;
	}

	.empty-icon-circle {
		width: 64px;
		height: 64px;
		border-radius: 50%;
		background: #F8FAFC;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 14px;
	}

	.empty-catalog-state h4 {
		margin: 0 0 6px 0;
		font-size: 16px;
		font-weight: 700;
		color: #0F172A;
	}

	.empty-catalog-state p {
		margin: 0 0 18px 0;
		font-size: 13px;
		color: #64748B;
		max-width: 380px;
	}

	.btn-primary-empty {
		padding: 10px 20px;
		background: #FF6A00;
		color: #FFFFFF;
		font-weight: 700;
		font-size: 13px;
		border: none;
		border-radius: 8px;
		cursor: pointer;
		box-shadow: 0 2px 4px rgba(255, 106, 0, 0.2);
	}

	.btn-clear-empty {
		padding: 8px 16px;
		background: #F1F5F9;
		color: #334155;
		font-weight: 600;
		font-size: 12px;
		border: 1px solid #CBD5E1;
		border-radius: 6px;
		cursor: pointer;
	}
	/* Preço e Badges de Estoque no Card Administrativo */
	.price-stock-row {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 8px;
		margin-top: 6px;
	}

	.admin-stock-pill {
		display: inline-flex;
		align-items: center;
		gap: 4px;
		font-size: 11px;
		font-weight: 700;
		padding: 2px 7px;
		border-radius: 6px;
		line-height: 1.2;
		white-space: nowrap;
	}

	.admin-stock-pill.stock-available {
		background: #F1F5F9;
		color: #475569;
		border: 1px solid #E2E8F0;
	}

	.admin-stock-pill.stock-out {
		background: #FEE2E2;
		color: #B91C1C;
		border: 1px solid #FECACA;
	}

</style>
